import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    Modal,
    Button,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Form, Field } from 'react-final-form';
import { FieldArray} from "react-final-form-arrays"
import arrayMutators from "final-form-arrays"
import CheckboxGroup from "@/shared/components/form/CheckboxGroup"
import "../style.scss";

import axios from "axios";
import {buildIdArray} from '@/shared/helpers';
import { fetchUserProgramRoles } from "@/shared/apiHelper"
import { useDispatch, flashSuccess, flashError } from "@/shared/components/flash"

const isSuperAdminRole = (role) => {
    const roleName = String(
        role?.name || role?.label || role?.slug || role?.code || ''
    ).trim().toLowerCase();

    return roleName === 'super admin' || roleName === 'super-admin' || roleName === 'super_admin';
}

const AssignRoleModal = ({ program, user, roles, isOpen, toggle, theme, rtl, setTrigger, setParentTrigger, toggleParent }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [programRoles, setProgramRoles] = useState(null)
    const availableRoles = useMemo(
        () => (Array.isArray(roles) ? roles.filter((role) => !isSuperAdminRole(role)) : []),
        [roles]
    );
    const availableRoleIds = useMemo(
        () => new Set(availableRoles.map((role) => String(role?.id ?? role?.value))),
        [availableRoles]
    );

    useEffect(() => {
        if (user?.id) {
            setLoading(true);
            fetchUserProgramRoles(program.organization_id, user.id, program.id)
            .then( _roles => {
                let idArray = buildIdArray(_roles).filter((roleId) => availableRoleIds.has(String(roleId)))
                setProgramRoles(idArray)
                setLoading(false)
            })
        }
    }, [availableRoleIds, program?.id, program?.organization_id, user?.id])

    const onSubmit = values => {
        let data = {};
        data.is_organization_admin = false
        data.roles = values.roles
        axios.patch(`/organization/${program.organization_id}/program/${program.id}/user/${user.id}/assignRole`, data)
        .then((res) => {
            if (res.status < 300) {
                setTrigger(Math.floor(Date.now() / 1000))
                setParentTrigger(Math.floor(Date.now() / 1000))
                flashSuccess(dispatch, "Role(s) in Program updated!")
                toggle()
                if (toggleParent) toggleParent()
            }
            setLoading(false)
        })
        .catch(error => {
            setLoading(false)
            console.log(error.response.data);
            flashError(dispatch, error.response.data)
        })
    }

    const validate = values => {
        return true;
    }

    if( loading ) return 'Loading...'

    // console.log(roles)

    return (
        <Modal className={`modal-action manager-program-modal modal-md ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
                <ModalHeader tag="div" className="manager-program-modal__header assign-role-modal__header">
                    <h3 className="assign-role-modal__title">Role</h3>
                    <button
                        type="button"
                        className="assign-role-modal__close"
                        aria-label="Close"
                        onClick={toggle}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="manager-program-modal__body assign-role-modal__body">
                    <Form
                        onSubmit={onSubmit}
                        validate={validate}
                        initialValues={{roles: programRoles}}
                        mutators={{
                            ...arrayMutators
                        }}
                    >
                        {({ handleSubmit, form, submitting, pristine, values }) => (
                            <form className="form" onSubmit={handleSubmit}>
                                <Field name='roles'>
                                    {({ input, meta }) => (
                                        <div className="form__form-group assign-role-modal__group">
                                            <div className="form__form-group-field">
                                                <div className="form__form-group-row">
                                                    <FieldArray
                                                        component={CheckboxGroup}
                                                        options={availableRoles}
                                                        {...input}
                                                    />
                                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Field>
                                <div className='assign-role-modal__footer'>
                                    <Button type="button" className='assign-role-modal__action' onClick={toggle}>Close</Button>
                                    <Button className='assign-role-modal__action assign-role-modal__action--primary' disabled={loading} type='submit'>Submit</Button>
                                </div>
                            </form>
                        )}
                    </Form>
                </ModalBody>
        </Modal>
    )
}

AssignRoleModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};

export default connect((state) => ({
    theme: state.theme,
    rtl: state.rtl
}))(AssignRoleModal);
